<template lang="pug">
.open-loading-container
  .group(v-for="(item,index) in cards" :key="index")
    .module
      .title {{ item.title }}
        span(v-if="item.subtitle") ({{item.subtitle}})
      .subtitle
        span 价值
        span.unit --
    template(v-if="item.subtitle")
      .right-card
        .shadow-bike-item
        .or 或
        .shadow-bike-item
    template(v-else)
      .right-card
        .card-item(v-for="(coupon, index) in item.rightsGroups" :key="index")
          .shadow-coupon-item
</template>

<script>

const DEFAULT_CARDS = () => ([
  {
    title: '单车权益',
    subtitle: '权益二选一',
  },
  {
    title: '出行权益',
    subtitle: '',
    rightsGroups: [{}, {}, {}, {}, {}, {}],
  },
  {
    title: '生活权益',
    subtitle: '',
    rightsGroups: [{}, {}, {}],
  },
]);

export default {
  data() {
    return {
      cards: DEFAULT_CARDS(),
    };
  },
  methods: {
  },
};
</script>

<style lang="less" scoped>
.fontStyle(@lh: 0.36rem, @fs: 0.3rem, @fw: normal, @co: #fff) {
  line-height: @lh;
  font-size: @fs;
  font-weight: @fw;
  color: @co;
}

.vip-open-container {
  width: 100%;
  height: 100%;
  background-color: #f0f3f5;

  .module {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 0.2rem;

    .title {
      .fontStyle(0.25rem, 0.18rem, 500, #242729);

      > span {
        font-size: 0.16rem;
        margin-left: 0.1rem;
        font-weight: 400;
      }
    }

    .subtitle {
      .fontStyle(0.2rem, 0.14rem, 400, #000);
    }

    .unit {
      color: #d5261b;
    }
  }

  .right-card {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;

    .or {
      background: #d5261b;
      border-radius: 0.12rem;
      padding: 0.03rem 0.06rem;
      margin: auto 0.15rem;
      .fontStyle(0.2rem, 0.14rem, 400, #fff);
    }

    .shadow-bike-item {
      width: 1.38rem;
      height: 0.62rem;
      background: #f0f3f5;
      border-radius: 0.08rem;
      margin-top: 0.08rem;
    }

    .card-item {
      width: 0.76rem;
      margin-top: 0.08rem;

      &:not(:nth-child(4n+4)) {
        margin-right: 0.095rem;
      }

      .shadow-coupon-item {
        width: 0.76rem;
        height: 0.78rem;
        background: #f0f3f5;
        border-radius: 0.08rem;
      }
    }
  }
}
</style>
